import { render, staticRenderFns } from "./WorkforceHeatmap.vue?vue&type=template&id=120150bc&"
import script from "./WorkforceHeatmap.vue?vue&type=script&lang=js&"
export * from "./WorkforceHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports